import React from 'react'

const TargetIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 500 320"
        width="100%"
        height="100%"
        {...props}
    >
        <defs>
            {/* Soft Drop Shadow */}
            <filter id="soft-shadow" x="-10%" y="-10%" width="120%" height="120%">
                <feDropShadow
                    dx="0"
                    dy="4"
                    stdDeviation="6"
                    floodColor="#2c3e50"
                    floodOpacity="0.08"
                />
            </filter>
        </defs>

        <style>
            {`
      .bg-blob { fill: #e8f6f3; opacity: 0.75; }
      .dark-outline { stroke: #3a4b5c; stroke-width: 4; stroke-linecap: round; stroke-linejoin: round; }
      .gear-fill { fill: #eef4f8; stroke: #a3b8cc; stroke-width: 2.5; stroke-linejoin: round; }
      .line-placeholder { stroke: #b0bec5; stroke-width: 3.5; stroke-linecap: round; }
    `}
        </style>

        {/* BACKGROUND BLOBS */}
        <g className="bg-blob">
            <path d="M 120 180 C 100 120, 140 50, 220 40 C 280 30, 320 10, 380 40 C 430 70, 420 150, 440 210 C 460 270, 360 300, 280 290 C 200 280, 140 240, 120 180 Z" />
            <path d="M 100 220 C 80 180, 110 130, 150 140 C 180 150, 180 220, 150 250 C 120 270, 110 240, 100 220 Z" />
        </g>

        {/* BACKGROUND GEARS */}
        {/* Upper Right Small Gear */}
        <g transform="translate(365, 100) scale(0.65)" className="gear-fill">
            <path d="M -5 -25 L 5 -25 L 7 -18 A 20 20 0 0 1 18 -7 L 25 -5 L 25 5 L 18 7 A 20 20 0 0 1 7 18 L 5 25 L -5 25 L -7 18 A 20 20 0 0 1 -18 7 L -25 5 L -25 -5 L -18 -7 A 20 20 0 0 1 -7 -18 Z" />
            <circle cx="0" cy="0" r="8" fill="#ffffff" stroke="#a3b8cc" strokeWidth="2.5" />
        </g>

        {/* Middle Right Large Gear */}
        <g transform="translate(400, 160) scale(1)" className="gear-fill">
            <path d="M -6 -32 L 6 -32 L 9 -23 A 26 26 0 0 1 23 -9 L 32 -6 L 32 6 L 23 9 A 26 26 0 0 1 9 23 L 6 32 L -6 32 L -9 23 A 26 26 0 0 1 -23 9 L -32 6 L -32 -6 L -23 -9 A 26 26 0 0 1 -9 -23 Z" />
            <circle cx="0" cy="0" r="12" fill="#ffffff" stroke="#a3b8cc" strokeWidth="2.5" />
        </g>

        {/* Lower Right Medium Gear */}
        <g transform="translate(360, 220) scale(0.85)" className="gear-fill">
            <path d="M -6 -28 L 6 -28 L 8 -20 A 22 22 0 0 1 20 -8 L 28 -6 L 28 6 L 20 8 A 22 22 0 0 1 8 20 L 6 28 L -6 28 L -8 20 A 22 22 0 0 1 -20 8 L -28 6 L -28 -6 L -20 -8 A 22 22 0 0 1 -8 -20 Z" />
            <circle cx="0" cy="0" r="10" fill="#ffffff" stroke="#a3b8cc" strokeWidth="2.5" />
        </g>

        {/* Lower Left Gear */}
        <g transform="translate(170, 225) scale(0.9)" className="gear-fill" opacity="0.85">
            <path d="M -6 -28 L 6 -28 L 8 -20 A 22 22 0 0 1 20 -8 L 28 -6 L 28 6 L 20 8 A 22 22 0 0 1 8 20 L 6 28 L -6 28 L -8 20 A 22 22 0 0 1 -20 8 L -28 6 L -28 -6 L -20 -8 A 22 22 0 0 1 -8 -20 Z" />
            <circle cx="0" cy="0" r="10" fill="#ffffff" stroke="#a3b8cc" strokeWidth="2.5" />
        </g>

        {/* CHECKMARKS */}
        {/* Top Right Checkmark */}
        <g transform="translate(345, 42)">
            <circle cx="0" cy="0" r="15" fill="#aee2d1" />
            <path
                d="M -6 0 L -2 4 L 6 -4"
                stroke="#ffffff"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
        </g>

        {/* Left Checkmark */}
        <g transform="translate(155, 100)">
            <circle cx="0" cy="0" r="16" fill="#bfeadc" />
            <path
                d="M -6 -1 L -2 3 L 6 -5"
                stroke="#ffffff"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
        </g>

        {/* Far Left Subtle Checkmark */}
        <g transform="translate(122, 172)" opacity="0.6">
            <circle cx="0" cy="0" r="14" fill="#ffffff" stroke="#cfd8dc" strokeWidth="1.5" />
            <path
                d="M -5 -1 L -1 3 L 5 -3"
                stroke="#b0bec5"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
        </g>

        {/* SPARKLE / STAR */}
        <g transform="translate(208, 38)" stroke="#aee2d1" strokeWidth="2" strokeLinecap="round">
            <line x1="0" y1="-5" x2="0" y2="5" />
            <line x1="-5" y1="0" x2="5" y2="0" />
        </g>

        {/* MAIN CLIPBOARD */}
        <g filter="url(#soft-shadow)">
            {/* Board Base */}
            <rect x="188" y="70" width="124" height="205" rx="12" fill="#3a4b5c" className="dark-outline" />

            {/* Paper Sheet */}
            <rect x="198" y="80" width="104" height="185" rx="4" fill="#ffffff" />

            {/* Folded Bottom Corner */}
            <path d="M 282 265 L 302 245 L 282 245 Z" fill="#b0bec5" />
            <path
                d="M 302 245 L 282 245 L 282 265 L 294 265 C 298.4 265 302 261.4 302 257 Z"
                fill="#cfd8dc"
                stroke="#3a4b5c"
                strokeWidth="2.5"
                strokeLinejoin="round"
            />

            {/* Top Metallic Clip */}
            <rect x="220" y="62" width="60" height="12" rx="3" fill="#2c3a47" />
            <path
                d="M 226 66 L 274 66 C 277 66 279 64 279 61 L 275 48 C 274 45 271 43 268 43 L 232 43 C 229 43 226 45 225 48 L 221 61 C 221 64 223 66 226 66 Z"
                fill="#80e0c4"
                stroke="#3a4b5c"
                strokeWidth="3.5"
                strokeLinejoin="round"
            />
            <circle cx="250" cy="51" r="3.5" fill="#ffffff" stroke="#3a4b5c" strokeWidth="2" />
        </g>

        {/* TARGET / BULLSEYE */}
        <g transform="translate(250, 150)">
            <circle cx="0" cy="0" r="34" fill="none" stroke="#3dbd98" strokeWidth="5" />
            <circle cx="0" cy="0" r="22" fill="none" stroke="#3dbd98" strokeWidth="4.5" />
            <circle cx="0" cy="0" r="10" fill="none" stroke="#3dbd98" strokeWidth="4" />
            <circle cx="0" cy="0" r="4" fill="#3dbd98" />

            {/* ARROW */}
            <g transform="rotate(-45)">
                <line x1="0" y1="0" x2="42" y2="0" stroke="#3a4b5c" strokeWidth="3.5" strokeLinecap="round" />
                <polygon points="0,0 8,-4 8,4" fill="#3a4b5c" />
                <g transform="translate(42, 0)">
                    <path d="M -12,-8 L 0,-12 L -4,0 L 0,12 L -12,8 L -7,0 Z" fill="#3a4b5c" />
                </g>
            </g>
        </g>

        {/* TEXT PLACEHOLDER LINES */}
        <line x1="218" y1="208" x2="282" y2="208" className="line-placeholder" />
        <line x1="228" y1="219" x2="272" y2="219" className="line-placeholder" />
    </svg>
)

export default TargetIcon
